export default class StringFormatUtil{

    static pad(num:number, size:number, character = "0") {
        var s = character.repeat(size) + num;
        return s.substr(s.length-size);
    }
}